<template>
  <div class="opple-ability-ui-com-timeRange">
    <el-time-picker
      v-model="value"
      format="HH:mm"
      :placeholder="$t('iftttset.SelecTime')"
    />
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      value: '',
    }
  },
  mounted() {
    this.setTime();
  },

  methods: {
    setTime() {
      const { DefaultValue } = this.item;
      if (!DefaultValue) return;
      this.value = moment().hour(DefaultValue / 60).minutes(DefaultValue % 60);
    },
    getData() {
      const start = moment(this.value, "HH:mm");
      const sTime = start.hours() * 60 + start.minutes()

      return {
        Key: this.item.KeyId,
        Values: ['' + sTime]
      }
    },
  },
};
</script>

<style lang="scss">
.opple-ability-ui-com-timeRange {
  display: flex;
  justify-content: space-between;

  &>div {
    width: 100% !important;

    i:after {
      display: none !important;
    }
    i:before {
      display: none !important;
    }
  }
}
</style>